module.exports = __webpack_public_path__ + "static/media/15.831de2e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_41/images/悬浮窗/15.png
// module id = 980
// module chunks = 0